export default "__VITE_ASSET__BirMBQnc__"